/**
 * 1-based positions in a rendered feed where promoted events are injected.
 *
 * Shared by every tab so an ad lands in the same visual slot regardless of which feed the user is on.
 */
export const PROMOTED_EVENTS_RANKS = [1, 4, 9];

// When the early access card takes slot 1, the first ad moves to slot 2; the rest keep their sold slots.
export const PROMOTED_EVENTS_RANKS_WITH_EARLY_ACCESS = [2, 4, 9];

// 1-based positions the early access cards occupy; the first N ranks are used for N cards (max four).
export const EARLY_ACCESS_EVENT_RANKS = [1, 3, 6, 8];
